
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'CatalogLookup',
  components: {
    TLookupSkin,
  },
})
export default class CatalogLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'Catalog';
  }

  keyPrefix() {
    return 'Catalog';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }

  linkClick(productId, row) {
    const item = {
      key: `${this.keyPrefix()}-${productId}`,
      title: row.CODE.value,
    };
    this.addItem(item);
    if (!this.multipleSelection) {
      this.dialogVisible = false;
    }
  }
}
